export function isIteratorSymbols(key?: PropertyKey): boolean {
  return key === Symbol.iterator || key === Symbol.asyncIterator
}
